import { Box, Button, Container, Grid, Tab, Tabs, Typography, Stack, Divider } from "@mui/material"
import { useState, useEffect, createRef, useRef } from 'react'
import PropTypes from 'prop-types';
import { Formik, Form, Field } from "formik";
import { TextField } from 'formik-mui';
import * as Yup from 'yup';
import { alertMsg } from '../../utils/basicUtils';
import useAxiosPrivate from "../../hooks/use-axios-private";
import { useTheme } from '@emotion/react'
import PhoneInput from 'react-phone-input-2'
import { ErrorMessage } from 'formik';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import ModeEditOutlinedIcon from '@mui/icons-material/ModeEditOutlined';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import useAuth from "../../hooks/use-auth";
import { authActions } from "../../redux/reducers/auth-slice";
import { useDispatch } from 'react-redux'
import ModalBox from '../../components/ModalBox'
import CropIcon from '@mui/icons-material/Crop';
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import 'react-phone-input-2/lib/style.css'
import Popup from "../../components/Popup";
import useSignout from "../../hooks/use-signout";

function TabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && (
				<Box sx={{ py: 3 }}>
					<Typography component={"div"}>{children}</Typography>
				</Box>
			)}
		</div>
	);
}

TabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.number.isRequired,
	value: PropTypes.number.isRequired,
};


const ProfilePage = () => {
	const theme = useTheme()
	const { user } = useAuth()
	const dispatch = useDispatch()
	const [tabValue, setTabValue] = useState(0);
	const [employeeId, setEmployeeId] = useState(false);
	const [profile, setProfile] = useState({
		"email": "",
		"first_name": "",
		"last_name": "",
		"mobile_number": "",
		"country_code": '',
		"mobile_code": '',
		"street": '',
		"username": '',
		"city": '',
		"state": '',
		"country": '',
		"zipcode": '',
	})
	const axios = useAxiosPrivate()
	const signout = useSignout()
	const [viewIconInCurrentPassword, setViewIconInCurrentPassword] = useState(false)
	const [viewIconInNewPassword, setViewIconInNewPassword] = useState(false)
	const [viewIconInConfirmPassword, setViewIconInConfirmPassword] = useState(false)
	const [headshot, setHeadshot] = useState("")
	const [showDeleteModal, setShowDeleteModal] = useState(false)
	const [isOpen, setIsOpen] = useState(false)
	const cropperRef = createRef();
	const handleImageControllerRef = useRef(false)

	const handleTabChange = (event, newValue) => {
		setTabValue(newValue);
	};

	// const handleChangeswitch = (event: React.SyntheticEvent, newValue: string) => {
	//   setValue(newValue);
	// };
	const usersProfile = async () => {
		try {
			const resp = await axios.get("users/profile/")
			setProfile(resp.data.data.user)
			if (resp.data.data.employee) {
				setEmployeeId(resp.data.data.employee.employee_id)
			}
			if (resp.data.data.user.headshot) {
				setHeadshot(resp.data.data.user.headshot.url)
			}
		}
		catch (err) {
			console.error(err)
		}
	}

	const getCropData = async () => {
		const croppedCanvas = cropperRef.current?.cropper.getCroppedCanvas();
		croppedCanvas.toBlob(async (blob) => {
			const splitTimeStamp = headshot.split('?')
			const filename = splitTimeStamp[0].split('/').pop();
			const imageFile = new File([blob], filename, { type: "image/jpeg" });
			const res = {
				target: {
					files: [imageFile]
				}
			}
			handleImageChange(res)
			setIsOpen(false);
		}, "image/jpeg");
	};

	const handleImageChange = async (e) => {
		try {
			const ext = e.target.files[0].name.split('.').pop().toLowerCase();
			if (e.target.files[0].size < 10000000) {
				if (['jpg', 'jpeg', 'png'].includes(ext)) {
					const formdata = new FormData()
					formdata.append('media_type', 'image')
					formdata.append('image', e.target.files[0])
					const resp = await axios.put('users/upload_headshot/', formdata,
						{
							headers: {
								"Content-Type": "multipart/form-data",
							},
							signal: handleImageControllerRef.current.signal
						}
					)
					alertMsg(resp.data.message, "success")
					setHeadshot(resp.data.data.user.headshot.url)
					dispatch(authActions.updateHeadshot(resp.data.data.user.headshot))
					e.target.value = null;
				}
				else {
					alertMsg("Unsupported file format", 'warning')
				}
			}
			else {
				alertMsg("File size should be less than 10MB", 'warning')
			}
		}

		catch (e) {
			console.error("?? ~ file: PhotoSettings.jsx:102 ~ handleImageChange ~ e:", e)
		}
	}

	const handleEditImage = () => {
		setIsOpen(true)
	}

	const deleteUser = async () => {
		try {
			let resp = await axios.delete(`users/delete/${user.id}`)
			alertMsg(resp.data.message, 'success')
			signout()
		}
		catch (error) {
			console.error(error)
		}
	}

	useEffect(() => {
		handleImageControllerRef.current = new AbortController()
		usersProfile()
		return () => {
			handleImageControllerRef.current.abort()
		}
	}, []);

	return (
		<Box>
			<Container maxWidth="xl">
				<Box sx={{ mb: 2, mt: 3 }}>
					<Typography sx={{ position: 'relative', pl: 1, fontSize: { xs: 20, md: 22, xl: 25 }, fontWeight: theme.palette.mode === "dark" ? '400' : '500', "&::after": { content: '""', position: 'absolute', background: '#f764a3', width: '3px', left: 0, top: '12.5%', bottom: '12.5%', borderRadius: 1 } }}>Profile</Typography>
				</Box>

				<Box sx={{ width: '100%' }}>
					<Box sx={{ borderBottom: 1, borderColor: 'divider', mt: 2 }}>
						<Tabs
							value={tabValue}
							onChange={handleTabChange}
							variant="scrollable"
							scrollButtons="auto"
						>
							<Tab label="Account details" />
							<Tab label="Change Password" />
							{/* <Tab label="Notification" /> */}
						</Tabs>
					</Box>

					<Formik
						initialValues={{ ...profile }}
						enableReinitialize={true}
						validationSchema={
							Yup.object().shape({
								first_name: Yup.string()
									.required('First name is required')
									.matches(/^[a-zA-Z\s]+$/, 'First name cannot contain special character and numbers')
									.min(3, 'First name must be at least 3 characters')
									.max(35, 'First name cannot exceed 35 characters'),
								last_name: Yup.string()
									.matches(/^[a-zA-Z\s]+$/, 'Last name cannot contain special character and numbers')
									.min(1, 'Last name minimum have 1 characters')
									.max(35, 'Last name cannot exceed 35 characters'),
								mobile_number: Yup.string()
									.required('Mobile Number is required')
									.min(10, 'Mobile number must be at least 10 numbers')
									.max(15, 'Mobile number cannot exceed 15 characters'),
								email: Yup.string().email()
									.required('Invalid email address')
									.required('Email is required'),
								username: Yup.string()
									.matches(/^[a-zA-Z0-9_]+$/, 'Invalid Username')
									.min(3, 'User name must be at least 3 numbers')
									.max(35, 'User name cannot exceed 35 characters'),
								street: Yup.string()
									.nullable()
									.max(50, 'Street cannot exceed 50 characters'),
								city: Yup.string()
									.nullable()
									.matches(/^[a-zA-Z\s]+$/, 'This City cannot contain special character and numbers')
									.max(50, 'City cannot exceed 50 characters'),
								state: Yup.string()
									.nullable()
									.matches(/^[a-zA-Z\s]+$/, 'This State cannot contain special character and numbers')
									.max(50, 'State cannot exceed 50 characters'),
								zipcode: Yup.string()
									.nullable()
									.matches(/^[aA-zZ0-9\s]+$/, 'Invalid zipcode')
									.max(50, 'zipcode cannot exceed 50 characters'),
							})
						}
						onSubmit={async (values, { setSubmitting }) => {
							try {
								const response = await axios.put(`users/update/`, { ...values, user_id: user.id })
								alertMsg(response.data.message, "success")
							}
							catch (err) {
								console.error(err)
							}
							setSubmitting(false);
						}}

					>

						{
							({ setFieldValue, values, setFieldTouched, isSubmitting }) => (
								<Form>
									<TabPanel value={tabValue} index={0}>
										<Box sx={{ flexGrow: 1, mt: 2 }}>
											<Grid container spacing={{ xs: 3, }} columns={{ xs: 4, sm: 12, md: 12 }} sx={{ alignItems: { xs: 'start', sm: "center" }, flexDirection: { xs: 'column-reverse', sm: 'row' } }}>
												<Grid item xs={12} sm={6} sx={{ flexGrow: '1', width: '100%' }}>
													<Box>
														<Field
															component={TextField}
															name="first_name"
															label="First Name *"
															inputProps={{ maxLength: 35 }}
															fullWidth
														/>
													</Box>
													<Box sx={{ mt: 4 }}>
														<Field
															component={TextField}
															name="last_name"
															label="Last Name "
															inputProps={{ maxLength: 35 }}
															fullWidth
														/>
													</Box>
												</Grid>
												<Grid item xs={12} sm={6} sx={{ flexGrow: '1', width: '100%' }}>
													<Box sx={{ height: "180px", width: "180px", marginLeft: "auto", borderRadius: "50%", marginRight: "auto", border: headshot === "" ? "2px dashed lightgrey" : 0, display: "flex", alignItems: "center", justifyContent: "center", position: 'relative' }}>
														<Button component="label" sx={{ p: 0, height: '100%', width: '100%', borderRadius: "50%" }}>
															{headshot === "" ? <Stack alignItems="center" justifyContent="center">
																<AccountCircleIcon sx={{ fontSize: { xs: 60, sm: 80, md: 100 }, color: "lightgrey" }} />
															</Stack> :
																<img style={{ width: "180px", height: "180px", objectFit: "cover", borderRadius: "50%", objectPosition: "top" }} src={headshot} alt="Profile Image"
																	loading="lazy"
																/>
															}
															<input hidden accept="image/*" type="file" onChange={handleImageChange} />
														</Button>
														{
															headshot !== "" && <Box sx={{ position: 'absolute', bottom: '10px', right: '10px', backgroundColor: theme.palette.primary.main, width: '35px', height: '35px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '50%', cursor: "pointer" }} onClick={handleEditImage}>
																<ModeEditOutlinedIcon sx={{ color: '#fff', fontSize: '16px' }} />
															</Box>
														}
													</Box>
													<ModalBox
														open={isOpen}
														onClose={() => { setIsOpen(false) }}
													>
														<Box sx={{ maxHeight: "80vh" }}>
															<Stack direction="row" alignItems="center" justifyContent="center">
																<Cropper
																	ref={cropperRef}
																	style={{ height: 400, width: "100%" }}
																	aspectRatio={4 / 3}
																	src={headshot}
																	viewMode={1}
																	minCropBoxHeight={10}
																	minCropBoxWidth={10}
																	background={false}
																	responsive={true}
																	autoCropArea={1}
																	checkOrientation={false}
																	guides={true}
																/>
															</Stack>
														</Box>
														<Box sx={{ mt: 3, textAlign: "center" }}>
															<Button variant="outlined" sx={{ mr: 2 }} onClick={() => { setIsOpen(false) }} color="error">Close</Button>
															<Button startIcon={<CropIcon />} onClick={getCropData} variant="outlined" color="primary">Crop</Button>
														</Box>
													</ModalBox>
												</Grid>
											</Grid>

											<Grid container spacing={{ xs: 3, }} columns={{ xs: 4, sm: 12, md: 12 }} sx={{ pt: 4 }}>
												{employeeId &&
													<Grid item xs={6}>
														<Field
															component={TextField}
															name="employeeid"
															label="Employee Id"
															value={employeeId}
															inputProps={{ maxLength: 50 }}
															disabled={true}
															fullWidth
														/>
													</Grid>
												}
												<Grid item xs={12} sm={6}>
													<Field
														component={TextField}
														name="username"
														label="User Name"
														fullWidth
														inputProps={{ maxLength: 35 }}
													/>
													<Box>
														<InfoOutlinedIcon sx={{ fontSize: "16px", color: "grey", verticalAlign: "middle" }}></InfoOutlinedIcon>
														<Typography sx={{ fontSize: "14px", color: "grey", verticalAlign: "middle", marginLeft: "5px" }} variant="span">Note:</Typography>
														<Typography sx={{ fontSize: "14px", marginLeft: "5px", color: "grey", verticalAlign: "middle" }} variant="span">Username can contain Alphanumeric charecters and underscore</Typography>
													</Box>
												</Grid>
												<Grid item xs={12} sm={6}>
													<Field
														component={TextField}
														name="email"
														label="Email *"
														disabled={true}
														inputProps={{ maxLength: 235 }}
														fullWidth
													/>
												</Grid>
												<Grid item xs={12} sm={6}>
													{/* <Field
												component={MuiTextField}
												name="mobile_number"
												label="Phone Number"
												fullWidth
											/> */}
													<PhoneInput
														className="phone-inp"
														country={'us'}
														value={(values.mobile_code ? values.mobile_code : "+1") + (values.mobile_number ? values.mobile_number : "")}
														onBlur={() => { setFieldTouched({ 'mobile_number': true }) }}
														onChange={(mobileNumber, mobileNumberObj) => {
															setFieldValue('mobile_number', mobileNumber.slice(mobileNumberObj.dialCode.length))
															setFieldValue('mobile_code', mobileNumberObj.dialCode)
															setFieldValue('country_code', mobileNumberObj.countryCode)
														}}
														fullWidth
													/>
													<ErrorMessage name="mobile_number" />
												</Grid>
												{/* <Grid item xs={12} sm={6}>
											<Field
												component={MuiTextField}
												name="companyName"
												label="Company Name"
												fullWidth
											/>
										</Grid> */}
												<Grid item xs={6}>
													<Field
														component={TextField}
														name="street"
														label="Street"
														inputProps={{ maxLength: 50 }}
														fullWidth
													/>
												</Grid>
												<Grid item xs={6}>
													<Field
														component={TextField}
														name="city"
														label="City"
														inputProps={{ maxLength: 50 }}
														fullWidth
													/>
												</Grid>
												<Grid item xs={6}>
													<Field
														component={TextField}
														name="state"
														label="State"
														inputProps={{ maxLength: 50 }}
														fullWidth
													/>
												</Grid>
												<Grid item xs={6}>
													<Field
														component={TextField}
														name="country"
														label="Country"
														fullWidth
													/>
													{/* <Country name="country" /> */}
												</Grid>
												<Grid item xs={6}>
													<Field
														component={TextField}
														name="zipcode"
														label="Postcode"
														inputProps={{ maxLength: 50 }}
														fullWidth
													/>
												</Grid>
											</Grid>
											<Box sx={{ textAlign: "right" }}>
												<Button variant="outlined" sx={{ mt: 5 }} type="submit" disabled={isSubmitting}>Update</Button>
											</Box>
											{/* <Divider sx={{ mt: 3, mb: 3 }}></Divider> */}
											<Box sx={{ pt: 2 }}>
												<Grid container spacing={{ xs: 3, }}>
													<Grid item xs={12} sm={8} md={6} xl={5}>
														<Box sx={{ boxShadow: "0 5px 15px rgba(0,0,0,.08)", p: 3, borderRadius: "6px", }}>
															<Box>
																<Typography sx={{ color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main, fontSize: { xs: 18, xl: 20 }, fontWeight: 500 }}>Delete your account</Typography>
															</Box>
															<Box sx={{ mt: 0.5 }}>
																<Typography sx={{ fontSize: { xs: 14, xl: 15 } }}>Deleting your account is irreversible and can affect your past activites.</Typography>
															</Box>
															<Box>
																<Button onClick={() => setShowDeleteModal(true)} color="error" variant="contained" sx={{ mt: 3 }} >Delete Account</Button>
															</Box>
														</Box>
													</Grid>
												</Grid>
											</Box>
										</Box>
									</TabPanel>
								</Form>
							)
						}
					</Formik>
					<TabPanel value={tabValue} index={1}>
						<Box sx={{ flexGrow: 1, mt: 3 }}>
							<Formik
								initialValues={{
									current_password: '',
									new_password: '',
									confirm_password: '',
								}}
								validationSchema={
									Yup.object().shape({
										current_password: Yup.string()
											.required('Current password is required'),
										// .matches(/^[^\s][ A-Za-z0-9_@./#&+-]+[^\s]$/, 'Password cannot contain whiteSpaces at the beginning and at the end'),
										new_password: Yup.string()
											.required("New password is required")
											// .matches(/^[^\s][ A-Za-z0-9_@./#&+-]+[^\s]$/, 'Password cannot contain whiteSpaces at the beginning and at the end')
											.min(8, "Must be at least 8 characters")
											.max(12, "New Password cannot exceed 12 characters"),
										confirm_password: Yup.string()
											.required("confirm password is required")
											.oneOf([Yup.ref('new_password'), null], "Passwords doesn't match"),
									})
								}

								onSubmit={async (values, { setSubmitting, resetForm }) => {
									try {
										const response = await axios.put("users/update_password/", values)
										alertMsg(response.data.message, 'success')
										resetForm()
									}
									catch (error) {
										console.error(error)
									}
									setSubmitting(false);
								}}
							>
								<Form>
									<Grid
										container
										spacing={{ xs: 3, md: 4 }} columns={{ xs: 4, sm: 12, md: 12 }}>
										{/* <Grid item xs={6}>
											<Field
												component={TextField}
												name="current_password"
												label="Current password *"
												type="password"
												inputProps={{ maxLength: 15 }}
												fullWidth
											/>
										</Grid> */}
										<Grid item xs={6}>
											<Box sx={{ position: "relative" }}>
												<Field
													component={TextField}
													name="current_password"
													label="Current Password *"
													type={!viewIconInCurrentPassword ? "password" : "text"}
													inputProps={{ maxLength: 15 }}
													fullWidth
													InputProps={{
														endAdornment:
															<InputAdornment position="end">
																<IconButton
																	onClick={() => { setViewIconInCurrentPassword(prev => !prev) }}
																	edge="end"
																>
																	{!viewIconInCurrentPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
																</IconButton>
															</InputAdornment>
													}}
												/>
												{/* <Box sx={{ position: "absolute", top: "28%", right: "3%" }}> */}
											</Box>
										</Grid>
										{/* <Grid item xs={6}>
											<Field
												component={TextField}
												name="new_password"
												label="New password *"
												type="password"
												inputProps={{ maxLength: 15 }}
												fullWidth
											/>
										</Grid> */}

										<Grid item xs={6}>
											<Box sx={{ position: "relative" }}>
												<Field
													component={TextField}
													name="new_password"
													label="New Password *"
													type={!viewIconInNewPassword ? "password" : "text"}
													inputProps={{ maxLength: 15 }}
													fullWidth
													InputProps={{
														endAdornment:
															<InputAdornment position="end">
																<IconButton
																	onClick={() => { setViewIconInNewPassword(prev => !prev) }}
																	edge="end"
																>
																	{!viewIconInNewPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
																</IconButton>
															</InputAdornment>
													}}
												/>
											</Box>
										</Grid>
										{/* <Grid item xs={6}>
											<Field
												component={TextField}
												name="confirm_password"
												label="Confirm New password *"
												type="password"
												inputProps={{ maxLength: 15 }}
												fullWidth
											/>
										</Grid> */}
										<Grid item xs={6}>
											<Box sx={{ position: "relative" }}>
												<Field
													component={TextField}
													name="confirm_password"
													label="Confirm New Password *"
													type={!viewIconInConfirmPassword ? "password" : "text"}
													inputProps={{ maxLength: 15 }}
													fullWidth
													InputProps={{
														endAdornment:
															<InputAdornment position="end">
																<IconButton
																	onClick={() => { setViewIconInConfirmPassword(prev => !prev) }}
																	edge="end"
																>
																	{!viewIconInConfirmPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
																</IconButton>
															</InputAdornment>
													}}
												/>
												{/* <Box sx={{ position: "absolute", top: "28%", right: "3%" }}> */}
											</Box>
										</Grid>
									</Grid>
									<Box sx={{ textAlign: "right" }}>
										<Button variant="outlined" sx={{ mt: 3 }} type="submit">Update</Button>
									</Box>
								</Form>
							</Formik>
						</Box>
					</TabPanel>
					{/* <TabPanel value={tabValue} index={2}>
						<Box sx={{ width: '100%', mt: 3 }}>
							<Grid container spacing={{ xs: 3, md: 2 }} columns={{ xs: 4, sm: 12, md: 12 }}>
								<Grid item xs={12} sm={6}>
									<Box>
										<Switch {...label} />
										<Typography variant='span' sx={{ fontSize: 15 }}>Project Comments</Typography>
									</Box>
								</Grid>
								<Grid item xs={12} sm={6}>
									<Box>
										<Switch {...label} />
										<Typography variant='span' sx={{ fontSize: 15 }}>Project Completed</Typography>
									</Box>
								</Grid>
								<Grid item xs={12} sm={6}>
									<Box >
										<Switch {...label} />
										<Typography variant='span' sx={{ fontSize: 15 }}>Project Rating</Typography>
									</Box>
								</Grid>
								<Grid item xs={12} sm={6}>
									<Box >
										<Switch {...label} />
										<Typography variant='span' sx={{ fontSize: 15 }}>Project Revision Completed</Typography>
									</Box>
								</Grid>
								<Grid item xs={12} sm={6}>
									<Box >
										<Switch {...label} />
										<Typography variant='span' sx={{ fontSize: 15 }}>Project Successful Upload</Typography>
									</Box>
								</Grid>
							</Grid>
						</Box>
					</TabPanel> */}
				</Box>

				{
					showDeleteModal
					&&
					<Popup variant={"error"} show={true} consent={true}
						primaryBtnTxt={"Delete"}
						onSecondaryClick={() => setShowDeleteModal(false)}
						onPrimaryClick={async (e, loader) => {
							try {
								loader(true)
								await deleteUser()
								setShowDeleteModal(false)
							}
							catch (error) {
								console.error(error)
							}
							finally {
								loader(false)
							}
						}}
						title={"Delete your account"}
					>
						<Box sx={{ mt: 2, textAlign: "center" }}>
							<Typography variant='span' sx={{ fontSize: { xs: "16px", xl: "18px" }, fontWeight: "400", color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}>Are you sure you want to delete your account ?</Typography>
						</Box>
						<Box sx={{ marginTop: "6px", textAlign: "center" }}>
							<Typography sx={{ fontSize: { xs: "16px", xl: "18px" }, fontWeight: "400", color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}>You can't undo this action.</Typography>
						</Box>
					</Popup>
				}
			</Container >
		</Box >
	)
}

export default ProfilePage